// resources.ts
import big from './translations/en.json';
import dashboardFaceliftResourcesEN from '../pages/DashboardFacelift/dashboardFaceliftResourcesEN.json';
import generalEn from './translations/generalEN.json';
import balanceUpTranslation from './translations/enBalanceUp.json';
import reportsEN from './translations/reportsEN.json';
import limitsEN from './translations/limitsEN.json';
import firstImperssionEN from './translations/firstImperssionEN.json';
import inviteEN from './translations/inviteEN.json';
import errorsEN from './translations/errorsEN.json';

export const resources = {
  en: {
    translation: {
      ...big,
      ...generalEn,
      ...dashboardFaceliftResourcesEN,
      ...balanceUpTranslation,
      ...reportsEN,
      ...limitsEN,
      ...firstImperssionEN,
      ...inviteEN,
      ...errorsEN,
    },
    generalEn,
    dashboardFaceliftResourcesEN,
    limitsEN,
    inviteEN,
    errorsEN,
    reportsEN,
    balanceUpTranslation,
    big,
    firstImperssionEN,
  },
} as const;
export const defaultNS = 'big';
